@if ($options(); as options) {
    <mat-form-field>
        <mat-select panelWidth="" [value]="$value()" (selectionChange)="changeValue($event.value)">
            @for (settingOption of options; track settingOption.value) {
                <mat-option [value]="settingOption.value">{{ settingOption.label }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
} @else {
    @switch ($valueType()) {
        @case ("float") {
            <cm-scalar-input-socket
                [type]="$socket().type"
                [label]="$socket().label"
                [connected]="$connected()"
                [value]="$valueAsNumber()"
                (valueChange)="changeValue($event)"
                [disableEditingIfConnected]="$disableEditingIfConnected()"
            >
            </cm-scalar-input-socket>
        }
        @case ("int") {
            <cm-scalar-input-socket
                [type]="$socket().type"
                [label]="$socket().label"
                [connected]="$connected()"
                [value]="$valueAsNumber()"
                (valueChange)="changeValue($event)"
                [disableEditingIfConnected]="$disableEditingIfConnected()"
            >
            </cm-scalar-input-socket>
        }
        @case ("boolean") {
            <cm-boolean-input-socket
                [label]="$socket().label"
                [connected]="$connected()"
                [value]="$valueAsBoolean()"
                (valueChange)="changeValue($event)"
                [disableEditingIfConnected]="$disableEditingIfConnected()"
            >
            </cm-boolean-input-socket>
        }
        @case ("color") {
            <cm-color-input-socket
                [type]="$socket().type"
                [label]="$socket().label"
                [connected]="$connected()"
                [value]="$valueAsColor()"
                (valueChange)="changeValue($event)"
                [disableEditingIfConnected]="$disableEditingIfConnected()"
            >
            </cm-color-input-socket>
        }
        @case ("vector") {
            <cm-vector-input-socket [label]="$socket().label" [connected]="$connected()" [value]="$valueAsVec3()" (valueChange)="changeValue($event)">
            </cm-vector-input-socket>
        }
        @case ("normal") {
            <cm-vector-input-socket [label]="$socket().label" [connected]="$connected()" [value]="$valueAsVec3()" (valueChange)="changeValue($event)">
            </cm-vector-input-socket>
        }
        <!--            @case ("output") {-->
        <!--                &lt;!&ndash; TODO separate component also for the 'output' type ? &ndash;&gt;-->
        <!--                <div>{{ $socket().label }}</div>-->
        <!--            }-->
        <!--            @case ("input") {-->
        <!--                &lt;!&ndash; TODO separate component also for the 'input' type ? &ndash;&gt;-->
        <!--                <div>{{ $socket().label }}</div>-->
        <!--            }-->
    }
}
